import { isElementOfType } from '@deephaven/react-hooks';
import { Tooltip } from "../popper/index.js";
import { Flex } from "./layout.js";
import { Text } from "./Text.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Tooltip for `<Item>` content.
 */
export function ItemTooltip(_ref) {
  var children = _ref.children,
    options = _ref.options;
  if (Array.isArray(children)) {
    return /*#__PURE__*/_jsx(Tooltip, {
      options: options,
      children: /*#__PURE__*/_jsx(Flex, {
        direction: "column",
        alignItems: "start",
        children: children.filter(node => isElementOfType(node, Text))
      })
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    options: options,
    children: children
  });
}
export default ItemTooltip;
//# sourceMappingURL=ItemTooltip.js.map